import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="text-center pt-3">
      This project was coded by{" "}
      <a href="https://github.com/andreamorinigo7">Andrea Morinigo</a> and is
      open-sourced on{" "}
      <a href="https://github.com/andreamorinigo7/dictionary-project">
        {" "}
        Github
      </a>
    </div>
  );
}
